import { GenericStateBlockCombinedProps } from './types';

const usePresenter = (props: GenericStateBlockCombinedProps): GenericStateBlockCombinedProps => {
  return props;
};

export default usePresenter;
